import React from 'react';
import styled from 'styled-components';
import { FormRow } from '@zocdoc-frontend-common/styles-grid';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { blue100 } from '@zocdoc-mezzanine/foundations-colors';
import PasswordRules from '../../../../PasswordRules/PasswordRules';
import { passwordField } from '../../../constants';
import PasswordField from './PasswordField';

/**
 * @param {boolean} hasErrors
 * @param {function(): void} onBlur
 * @param {function(): void} onChange
 * @param {function(): void} onFocus
 * @param {Object} statusChecks
 * @param {boolean} showStatusChecks
 * @returns {JSX.Element}
 * @constructor
 */
export default class PasswordFieldInline extends React.Component {
    render() {
        const {
            showStatusChecks,
            statusChecks,
            onFocus,
            onBlur,
            onChange,
            hasErrors,
        } = this.props;

        return (
            <FormRow>
                <FormLabel>Password</FormLabel>
                <PasswordField
                    onChange={(e) => {
                        onChange(passwordField, e.target.value);
                    }}
                    onFocus={() => onFocus(passwordField)}
                    onBlur={(e) => onBlur(passwordField, e.target.value)}
                    statusChecks={statusChecks}
                    showStatusChecks={showStatusChecks}
                    hasErrors={hasErrors}
                />

                {this.renderRules()}
            </FormRow>
        );
    }

    renderRules = () => {
        const { showStatusChecks, statusChecks } = this.props;

        if (showStatusChecks) {
            return (
                <PasswordRules
                    statusChecks={statusChecks}
                    animateRuleListAppearance={true}
                />
            );
        }
    };
}

const FormLabel = styled.div`
    color: ${blue100};
    font: 15px/24px ${FontFamily.SharpSansSemibold};
`;
